var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavouriteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.037,
    height: 24.037,
    viewBox: "0 0 24.037 24.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e76f51;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_79849",
    "data-name": "Path 79849",
    className: "cls-1",
    d: "M15.822,8.979v.029H4V-2.1A5.915,5.915,0,0,1,9.912-7.841a5.913,5.913,0,0,1,5.849,5.049,5.912,5.912,0,0,1,.061,11.772ZM14.346-1.314v-.679l-.005-.158A4.434,4.434,0,0,0,9.912-6.363,4.433,4.433,0,0,0,5.478-2.077V7.53h8.87V7.507l.821.023h.064a4.434,4.434,0,0,0,.007-8.868h-.083l-.132,0-.66.036v-.017Z",
    transform: "translate(2.717 20.496) rotate(-45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteIcon);
export default __webpack_public_path__ + "static/media/Favourite Icon.5441c10433a0011e37c12aa2d823747a.svg";
export { ForwardRef as ReactComponent };